import actionTypes from "../types";

const {
  GET_SHORTLISTED,
  GET_SHORTLISTED_SUCCESS,
  GET_SHORTLISTED_ERROR,
  UPDATE_SHORTLISTED,
  ADD_TO_SHORTLISTED,
  UPDATE_SHORTLISTED_SUCCESS,
  REMOVE_SHORTLISTED,
  REMOVE_SHORTLISTED_SUCCESS,
  SEND_INVITE,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_ERROR,
  GET_ROLE_DATA,
  GET_ROLE_DATA_ERROR,
  GET_ROLE_DATA_SUCCESS,
  GENERATE_TIERS,
  GENERATE_TIERS_SUCCESS,
  GENERATE_TIERS_ERROR,
  TIERS_JOB,
  TIERS_JOB_UPDATING,
  TIERS_JOB_SUCCESS,
  TIERS_JOB_ERROR,
  TIERS_JOB_CANCEL,
  BACKUP_TEMPLATE_SUCCESS,
  BACKUP_TEMPLATE_ERROR,
  CONFIRM_TEMPLATE_SUCCESS,
  CONFIRM_TEMPLATE_ERROR,
  GET_ROLE_SEARCH_OBJECT_SUCCESS,
  SEARCH_PEOPLE_SUCCESS,
  SEARCH_PEOPLE_FAILURE,
  GET_FILTERED_TIERS_LIST_SUCCESS,
  CLEAR_FILTERED_TIERS,
  CLEAR_SHORTLISTED,
  CLEAR_SHORTLISTED_SUCCESS,
  UPDATE_SHORTLISTED_STATUS_SUCCESS
} = actionTypes.tiers;

const initialState = {
  shortlisted: [],
  loading: false,
  roleSearchPayload: null,
  roleSearchTags: [],
  searchResults: [],
  searchPage: 1,
  hasMore: false,
  template: "",
  schedule: {
    date: "",
    time: "",
    timezone: ""
  },
  isGeneratingTiers: false,
  tiersJobId: "",
  tiers: [],
  inviteTemplate: "",
  inviteAllTemplate: "",
  confirmTemplate: "",
  backupTemplate: "",
  tiersFilter: [],
  tiersTags: [],
  filteredTiersData: [],
  totalFilteredTiersItemCount: 0,
  filteredTiersPageSize: 0,
  totalFilteredTiersPageCount: 0,
  filteredTiersListpagenumber: 0,
}

const tierReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHORTLISTED:
      return { ...state, loading: true };
    case GET_SHORTLISTED_SUCCESS:
      return {
        ...state,
        shortlisted: action?.response?.data || [],
        loading: false
      };
    case GET_SHORTLISTED_ERROR:
      return {
        ...state,
        loading: false,
        shortlisted: {}
      };
    case UPDATE_SHORTLISTED: 
      return { ...state, loading: true };

    case ADD_TO_SHORTLISTED: {
      if (state.shortlisted.find(t => t.uuid === action.response.uuid)) {
        return state;
      }

      return {
        ...state,
        shortlisted: [...state.shortlisted, action.response],
        loading: false
      };
    }

    case UPDATE_SHORTLISTED_SUCCESS: {
      return {
        ...state,
        shortlisted: action.response?.data || [],
        loading: false
      };
    }

    case REMOVE_SHORTLISTED: 
      return { ...state, loading: true };

    case REMOVE_SHORTLISTED_SUCCESS: {
      const uuid = action.response?.uuid;

      return {
        ...state,
        shortlisted: state.shortlisted.filter(item => item.roleUUID !== uuid),
        loading: false
      };
    }

    case CLEAR_SHORTLISTED:
      return { ...state, loading: true };

    case CLEAR_SHORTLISTED_SUCCESS: {
      const id = action.response?.id;

      return {
        ...state,
        shortlisted: state.shortlisted.filter(i => i.id !== id),
        loading: false
      };
    }

    case SEND_INVITE: 
      return { ...state, loading: true };

    case SEND_INVITE_SUCCESS:
    case UPDATE_SHORTLISTED_STATUS_SUCCESS: {
      const updatedItem = action.response?.updatedItem;

      if (!updatedItem) return state;
      return {
        ...state,
        shortlisted: state.shortlisted.map(item =>
          item.roleUUID === updatedItem.roleUUID
            ? updatedItem
            : item
        ),
        loading: false
      };
    }
    
    case GENERATE_TIERS:
      return { ...state, loading: true, isGeneratingTiers: true };

    case GENERATE_TIERS_SUCCESS: {
      const jobId = action.response?.id;

      return {
        ...state,
        tiersJobId: jobId,
        loading: false
      };
    }

    case SEND_INVITE_ERROR:
      return {
        ...state,
        loading: false,
        template: "",
        schedule: {
          date: "",
          time: "",
          timezone: ""
        }
      };

    case GET_ROLE_DATA:
      return { ...state, loading: true };

    case GET_ROLE_DATA_SUCCESS:
    case GET_ROLE_DATA_ERROR:
      return { ...state, loading: false };

    case GENERATE_TIERS_ERROR: {
      return {
        ...state,
        tiersJobId: "",
        loading: false,
        isGeneratingTiers: false
      };
    }

    case TIERS_JOB:
      return { ...state, loading: true, isGeneratingTiers: true };
    
    case TIERS_JOB_UPDATING: {
      const data = action.response;
      return {
        ...state,
        tiers: data
      };
    }

    case TIERS_JOB_SUCCESS:
      return { ...state, loading: false, isGeneratingTiers: false };
    
    case TIERS_JOB_ERROR:
    case TIERS_JOB_CANCEL:
      return {
        ...state,
        tiers: [],
        loading: false,
        isGeneratingTiers: false
      };

    case CONFIRM_TEMPLATE_SUCCESS:
      return {
        ...state,
        confirmTemplate: action.response.template,
        loading: false
      }
    
    case CONFIRM_TEMPLATE_ERROR:
      return {
        ...state,
        confirmTemplate: "",
        loading: false
      }
    
    case BACKUP_TEMPLATE_SUCCESS:
      return {
        ...state,
        backupTemplate: action.response.template,
        loading: false
      }
    
    case BACKUP_TEMPLATE_ERROR:
      return {
        ...state,
        backupTemplate: "",
        loading: false
      }

    case GET_ROLE_SEARCH_OBJECT_SUCCESS:
      return {
        ...state,
        roleSearchPayload: action.response.search_object,
        roleSearchTags: action.response.tags
      };

    case SEARCH_PEOPLE_SUCCESS: {
      const { results, reset, pageSize } = action.response;
      return {
        ...state,
        searchResults: reset
          ? results
          : [...state.searchResults, ...results],
        hasMore: results.length === pageSize,
        searchPage: reset ? 2 : state.searchPage + 1
      };
    }

    case SEARCH_PEOPLE_FAILURE:
      return {
        ...state,
        searchResults: [],
        hasMore: false
      };
    
    case GET_FILTERED_TIERS_LIST_SUCCESS:
      return {
        ...state,
        filteredTiersData: action.response.filteredTalentsList,
        totalFilteredTiersItemCount: action.response.totalItemCount,
        filteredTiersPageSize: action.response.pageSize,
        totalFilteredTiersPageCount: action.response.totalPageCount,
        filteredTiersListpagenumber: action.response.responsePagenumber,
      };

    case CLEAR_FILTERED_TIERS:
      return {
        ...state,
        filteredTiersData: [],
        totalFilteredTiersItemCount: 0,
        filteredTiersPageSize: 0,
        totalFilteredTiersPageCount: 0,
        filteredTiersListpagenumber: 0,
      };

    default:
      return { ...state };
  }
}

export default tierReducer;
